<template>
  <div v-show="!closed" class="callout" :class="type" aria-live="polite" role="status">
    <slot />
    <button v-show="closable" class="close-callout" type="button" @click.prevent="toggleClosed">
      <span class="iconfont-menu-close"></span>
    </button>
  </div>
</template>

<script>
// @flow
/**
 * Inline messages, for styling see partials/_modules.scss
 */
export default {
  name: 'Callout',
  props: {
    type: {
      type: String,
      required: true,
      validator: (val: String) => ['error', 'warning', 'success', 'info', 'standard'].includes(val),
    },
    closable: {
      type: Boolean,
      default: true,
    },
  },

  // component state
  data() {
    return {
      closed: false,
    }
  },

  // component methods
  methods: {
    toggleClosed() {
      this.closed = true
    },
  },
}
</script>
